import { render, staticRenderFns } from "./DormTabNav.vue?vue&type=template&id=f1e2141e&scoped=true&"
import script from "./DormTabNav.vue?vue&type=script&lang=js&"
export * from "./DormTabNav.vue?vue&type=script&lang=js&"
import style0 from "./DormTabNav.vue?vue&type=style&index=0&id=f1e2141e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e2141e",
  null
  
)

export default component.exports